export const SEARCH_PARAMS_TAB_KEY = 'tab'

/** Hardcoded tab ID for the Base Photos timeline - not customizable */
export const BASE_PHOTOS_TAB_ID = 'base-photos'

export const BASE_PHOTOS_TAB_LABEL = 'Photos'

/** Hardcoded tab ID for the PreTrip tab (same content as Volunteers Groups PreTrip) */
export const BASE_PRETRIP_TAB_ID = 'pretrip'

export const BASE_PRETRIP_TAB_LABEL = 'PreTrip'

/** Hardcoded tab ID for Hub About videos */
export const BASE_ABOUT_TAB_ID = 'about'

export const BASE_ABOUT_TAB_LABEL = 'About'
